import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const FAQsPage = () => <ComingSoon />;

export default FAQsPage;

